export const useCookie = () => ({
  getCookie: (key: string): string | undefined =>
    (
      document.cookie
        .split(';')
        .map(x => x.split('='))
        .reduce((prev, [key, value]) => ({ ...prev, [key.trim()]: value }), {}) as any
    )[key],
});
